import instance from '../../utils/API'
const axios = require('axios')

// Actions
const GET_ORDERS = 'redux/order/GET_ORDERS'
const GET_ORDERS_ERROR = 'redux/order/GET_ORDERS_ERROR'
const GET_ORDERS_SUCCESS = 'redux/order/GET_ORDERS_SUCCESS'


// Reducer
const initialState = {
    orders: [],
    isFetching: false,
    isError: false,
    orderError: null
}
const orders = (state = initialState, action) => {
    switch (action.type) {
        case GET_ORDERS_SUCCESS:
            return {
                ...state,
                orders: action.payload,
                isFetching: false,
                isError: false,
                orderError: null
            }
        
        case GET_ORDERS:
            return {
                ...state,
                isFetching: true,
                isError: false,
                orderError: null
            }

        case GET_ORDERS_ERROR:
            return {
                ...state,
                isFetching: false,
                isError: true,
                orderError: action.payload
            }
        default:
            return state
    }
}

export default orders
const getOrders = (access_token) => dispatch  => {

    dispatch({
        type: GET_ORDERS
    })

    instance(access_token).get("orders")
        .then(function (response) {
            if (response.data) {
            dispatch({
                type: GET_ORDERS_SUCCESS,
                payload: response.data
            })
        }
        })
        .catch(function (error) {
            let errMsg = "Network Error"
            if(error.response){
                errMsg = error.response
            }
            dispatch({
                type: GET_ORDERS_ERROR,
                payload: errMsg
            })

        })
}


export const orderActions = {
    getOrders,
}
